import { SearchContextActions, SearchContextsTypes, UpdateInputDataType } from './types';
import { setActressInfo, updateItem } from 'pages/Search/View/Main/action';
import { Dispatch, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SearchContexts } from './store';

interface Obj {
	[prop: string]: string;
}
const url = 'https://api.dmm.com/affiliate/v3/ActressSearch?';

export const useStyles = makeStyles({
	cardInfoErea: {
		padding: '20px',
		width: '100%',
		display: 'grid',
		gridTemplateColumns: 'repeat( auto-fill, minmax(250px,1fr) )',
		gridGap: '30px',
		justifyContent: 'center',
		backgroundColor: '#F0FFF4',
	},
	card: {
		width: '250px',
		display: 'grid',
		gridGap: '5px',
		placeItems: 'center',
		margin: '0 auto',
	},
	cardInfo: {
		width: '250px',
		padding: '0px 10px',
	},
	link: {
		display: 'block',
		margin: 'auto',
		textDecoration: 'none',
		color: 'black',
	},
	img: {
		display: 'block',
		margin: 'auto',
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
	movie: {
		display: 'block',
		margin: 'auto',
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
	title: {
		textDecoration: 'none',
		color: 'black',
	},
});

export const useInit: () => {
	updateInputData: UpdateInputDataType;
} = () => {
	const { dispatch } = useContext(SearchContexts);
	useEffect(() => {
		const params: Obj = {
			api_id: String(process.env.REACT_APP_DMM_APP_ID),
			affiliate_id: String(process.env.REACT_APP_DMM_AFFILIATE_ID),
			site: 'FANZA',
			service: 'digital',
			floor: 'videoa',
			hits: '100',
			get_bust: '80',
			gte_birshday: '2000-01-01',
			output: 'json',
		};

		getData(params, dispatch);
		console.log('初期処理');
	}, []);

	const updateInputData = (item: string, value: string) => {
		dispatch(updateItem({ item: item, value: value }));
	};

	return {
		updateInputData,
	};
};

export const fetchData = async (dispatch: Dispatch<SearchContextActions>, props: SearchContextsTypes) => {
	const { minBust, maxBust, minHeight, maxHeight, minBirthday, maxBirthday, keyword } = props;
	console.log('Search', minBust, maxBust, minHeight, maxHeight, minBirthday, maxBirthday, keyword);

	// 1. パラメタの作成
	const params: Obj = {
		api_id: String(process.env.REACT_APP_DMM_APP_ID),
		affiliate_id: String(process.env.REACT_APP_DMM_AFFILIATE_ID),
		site: 'FANZA',
		service: 'digital',
		floor: 'videoa',
		hits: '100',
		output: 'json',
	};

	// 2. 値が設定されている場合、paramsに追加
	if (minBust) params.get_bust = minBust;
	if (maxBust) params.lte_bust = maxBust;
	if (minHeight) params.gte_height = minHeight;
	if (maxHeight) params.lte_height = maxHeight;
	if (minBirthday) params.gte_birshday = minBirthday;
	if (maxBirthday) params.lte_birthday = maxBirthday;
	if (keyword) params.keyword = keyword;

	// 3. APIを呼び出して、コンテキストを更新
	getData(params, dispatch);
};

const getData = async (params: Obj, dispatch: Dispatch<SearchContextActions>) => {
	const query = new URLSearchParams(params);

	try {
		await fetch(`${url}${query}`)
			.then((res) => res.json())
			.then((data) => {
				console.log('data', data.result.actress);
				const nowDate = new Date();
				const records = data.result.actress
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					.filter((record: any) => record.imageURL)
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					.map((record: any) => {
						return {
							id: record.id,
							name: record.name,
							ruby: record.ruby,
							bust: record.bust,
							cup: record.cup,
							waist: record.waist,
							hip: record.hip,
							height: record.height,
							birthday: record.birthday,
							old: record.birthday ? ageCalculation(new Date(record.birthday), nowDate) : null,
							hobby: record.hobby,
							imageURL: record.imageURL?.large ?? '',
							listURL: record.listURL.digital ?? '',
						};
					});
				dispatch(setActressInfo({ actress: records }));
			});
	} catch (e) {
		console.log('error', e);
	}
};

const ageCalculation = (birthDate: Date, nowDate: Date) => {
	const age = nowDate.getFullYear() - birthDate.getFullYear();
	const thisYearsBirthday = new Date(nowDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
	return age + (thisYearsBirthday.getTime() > nowDate.getTime() ? -1 : 0);
};
